var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlob1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 67,
    rx: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9349 13H41.0129C39.3386 13 37.9642 14.3755 37.9642 16.0511V25.0044H27.9435C26.3192 25.0044 24.9948 26.3299 24.9948 27.9805V38.0092H15.9737C14.3244 38.0092 13 39.3347 13 40.9853V47.9879C13 49.6385 14.3244 50.964 15.9737 51.014H47.9599C49.6342 51.014 51.0086 49.6385 51.0086 47.9629V16.0511C50.9836 14.3755 49.6092 13 47.9349 13Z",
    fill: "url(#paint0_linear_7_43)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9349 13H41.0129C39.3386 13 37.9642 14.3755 37.9642 16.0511V25.0044H27.9435C26.3192 25.0044 24.9948 26.3299 24.9948 27.9805V38.0092H15.9737C14.3244 38.0092 13 39.3347 13 40.9853V47.9879C13 49.6385 14.3244 50.964 15.9737 51.014H47.9599C49.6342 51.014 51.0086 49.6385 51.0086 47.9629V16.0511C50.9836 14.3755 49.6092 13 47.9349 13Z",
    fill: "url(#paint1_linear_7_43)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9349 13H41.0628C39.3886 13 38.0142 14.3755 38.0142 16.0511V51.014H47.9349C49.6091 51.014 50.9835 49.6385 50.9835 47.9629V16.0511C50.9835 14.3755 49.6091 13 47.9349 13Z",
    fill: "#F57C00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9948 28.0055V38.0092H15.9987C14.3494 38.0092 13 39.3597 13 41.0103V48.0129C13 49.6635 14.3494 51.014 15.9987 51.014H37.9892V25.0044H27.9935C26.3442 25.0044 24.9948 26.3549 24.9948 28.0055Z",
    fill: "#FFC107"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9893 25.0044V51.014H47.91C49.5842 51.014 50.9586 49.6385 50.9586 47.9628V38.0092L37.9893 25.0044Z",
    fill: "url(#paint2_linear_7_43)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M27.9936 25.2545H37.9893V25.0044H27.9936C26.3443 25.0044 24.9949 26.3549 24.9949 28.0055V28.2556C24.9949 26.605 26.3443 25.2545 27.9936 25.2545Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.9987 38.2593H24.9948V38.0092H15.9987C14.3494 38.0092 13 39.3597 13 41.0103V41.2604C13 39.6098 14.3494 38.2593 15.9987 38.2593Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M47.9349 13H41.0628C39.3886 13 38.0142 14.3755 38.0142 16.0511V16.3012C38.0142 14.6256 39.3886 13.2501 41.0628 13.2501H47.9349C49.6091 13.2501 50.9835 14.6256 50.9835 16.3012V16.0511C50.9835 14.3755 49.6091 13 47.9349 13Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M47.9349 50.7639H15.9987C14.3494 50.7639 13 49.4134 13 47.7628V48.0129C13 49.6635 14.3494 51.014 15.9987 51.014H47.9099C49.5842 51.014 50.9586 49.6385 50.9586 47.9629V47.7128C50.9836 49.3884 49.6092 50.7639 47.9349 50.7639V50.7639Z",
    fill: "#BF360C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9349 13H41.0629C39.3886 13 38.0142 14.3755 38.0142 16.0511V25.0044H28.0185C26.3692 25.0044 25.0198 26.3549 25.0198 28.0055V38.0092H15.9987C14.3494 38.0092 13 39.3597 13 41.0103V48.0129C13 49.6635 14.3494 51.014 15.9987 51.014H47.9349C49.6092 51.014 50.9836 49.6385 50.9836 47.9629V16.0511C50.9836 14.3755 49.6092 13 47.9349 13Z",
    fill: "url(#paint3_linear_7_43)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_43",
    x1: 13,
    y1: 32.007,
    x2: 51.0086,
    y2: 32.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7_43",
    x1: 13,
    y1: 32.007,
    x2: 51.0086,
    y2: 32.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7_43",
    x1: 31.5545,
    y1: 31.5693,
    x2: 50.0889,
    y2: 50.0888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF360C",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF360C",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7_43",
    x1: 25.7367,
    y1: 25.7624,
    x2: 50.3273,
    y2: 50.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob1);
export default __webpack_public_path__ + "static/media/blob1.67e6566ac5ea9fca99cc8a2b8f6c2d3d.svg";
export { ForwardRef as ReactComponent };